<section class="contact-hero">
  <div class="container">
    <h1>Contact Us</h1>
    <p class="subtitle">
      Fill out the form below and our brokerage team will get back to you shortly.
    </p>
  </div>
</section>

<section class="contact-content">
  <div class="container">
    <div class="contact-grid">
      <div class="contact-info-card">
        <h3>Contact Information</h3>
        <p class="card-desc">
          Reach out to our team for expert yacht brokerage services today.
        </p>
        <div style="margin-bottom: 20px;">
          <p style="margin-bottom: 5px;">Office hours:</p>
          <div style="margin-left: 20px;">
            <table>
              <tr>
                <td>Monday - Friday</td>
                <td>:&nbsp; 9:00 AM - 5:00 PM</td>
              </tr>
              <tr>
                <td>Saturday</td>
                <td>:&nbsp; 10:00 AM - 4:00 PM</td>
              </tr>
              <tr>
                <td>Sunday</td>
                <td>:&nbsp; By Appointment</td>
              </tr>
            </table>
            <!-- Monday - Friday &nbsp; :&nbsp; 9:00 AM - 5:00 PM<br>
            Saturday &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;: 10:00 AM - 4:00 PM<br>
            Sunday &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;: By Appointment -->
          </div>
        </div>
        <div class="info-item">
          <span class="icon">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
              <path d="M12 18h.01"></path>
            </svg>
          </span>
          <div style="display: flex; flex-direction: column;">
            <span>{{ mainAddress()?.phone }}</span>
            <!-- <span>+1 713-245-6662</span> -->
          </div>
        </div>
        <div class="info-item">
          <span class="icon">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect width="20" height="16" x="2" y="4" rx="2"></rect>
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
            </svg>
          </span>
          <span>{{ mainAddress()?.email }}</span>
        </div>
        <div class="info-item">
          <span class="icon">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
              <path d="M2 12h20"></path>
            </svg>
          </span>
          <span>https://leaguecityyachtsales.com/</span>
        </div>
        <div class="info-item">
          <span class="icon">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </span>
          <span>
            <!-- {{ mainAddress()?.addressLine1 }}<br /> -->
            {{ mainAddress()?.addressLine2 }}<br />
            {{ mainAddress()?.city }}, {{ mainAddress()?.state }} {{ mainAddress()?.zipCode }}
            {{ mainAddress()?.country }}
          </span>
        </div>
        <p class="sms-notice">
                I agree to receive SMS notifications from League City Yacht Sales to receive automated responses from
                League City Yacht Sales. Msg & data rates may apply. Message frequency varies.
                Reply <strong>STOP</strong> to opt out, <strong>HELP</strong> for
                help, or email <strong>contact@leaguecityyachtsales.com</strong> with any questions or concerns and
                we’ll be happy to help. <br />See our <a routerLink="/privacy-policy" class="form-link">Privacy
                  Policy</a> and
                <a routerLink="/terms-of-service" class="form-link">Terms of Service</a>.
        </p>
        <div class="decorative-circle" aria-hidden="true"></div>
      </div>

      <div class="inquiry-form">
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div *ngIf="isSuccess()" class="success-banner" style="
              background: var(--success);
              color: white;
              padding: 1rem;
              border-radius: 8px;
              margin-bottom: 1rem;
            ">
            Your inquiry has been successfully sent! Our team will contact you soon.
          </div>
          <div *ngIf="isError()" class="error-banner" style="
              background: var(--error);
              color: white;
              padding: 1rem;
              border-radius: 8px;
              margin-bottom: 1rem;
            ">
            We encountered an error submitting your inquiry. Please try again.
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="firstName">First Name *</label>
              <input type="text" id="firstName" formControlName="firstName" placeholder="" />
              <div class="error-msg" *ngIf="
                  contactForm.get('firstName')?.touched &&
                  contactForm.get('firstName')?.errors?.['required']
                ">
                First Name is required.
              </div>
            </div>
            <div class="form-group">
              <label for="lastName">Last Name *</label>
              <input type="text" id="lastName" formControlName="lastName" placeholder="" />
              <div class="error-msg" *ngIf="
                  contactForm.get('lastName')?.touched &&
                  contactForm.get('lastName')?.errors?.['required']
                ">
                Last Name is required.
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="email">Email Address *</label>
              <input type="email" id="email" formControlName="email" placeholder="" />
              <div class="error-msg" *ngIf="
                  contactForm.get('email')?.touched &&
                  contactForm.get('email')?.errors?.['required']
                ">
                Email Address is required.
              </div>
              <div class="error-msg" *ngIf="
                  contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['email']
                ">
                Please enter a valid email address.
              </div>
            </div>
            <div class="form-group">
              <label for="phone">Phone *</label>
              <input type="tel" id="phone" formControlName="phone" placeholder="" />
              <div class="error-msg" *ngIf="
                  contactForm.get('phone')?.touched &&
                  contactForm.get('phone')?.errors?.['required']
                ">
                Phone is required.
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="message">Message *</label>
            <textarea id="message" formControlName="message" rows="4" placeholder="Write your notes..."></textarea>
            <div class="error-msg" *ngIf="
                contactForm.get('message')?.touched &&
                contactForm.get('message')?.errors?.['required']
              ">
              Message is required.
            </div>
            <div class="error-msg" *ngIf="
                contactForm.get('message')?.touched &&
                contactForm.get('message')?.errors?.['minlength']
              ">
              Message must be at least 10 characters.
            </div>
          </div>

          <div class="form-actions">
            <div class="form-footer-links">
              <a routerLink="/privacy-policy" class="form-link">Privacy Policy</a>
              <span class="divider">/</span>
              <a routerLink="/terms-of-service" class="form-link">Terms & Conditions</a>
            </div>
            <app-button type="submit" variant="primary" [disabled]="isSubmitting()">
              {{ isSubmitting() ? 'Sending...' : 'Request Information' }}
            </app-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- <section class="meet-broker-section" style="padding: 60px 0; background-color: #f9f9f9;">
  <div class="container">
    <div class="broker-detail-card"
      style="background: #fff; padding: 40px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.03); display: flex; gap: 40px; flex-wrap: wrap; align-items: flex-start;">
      <div class="broker-image" style="flex: 0 0 auto;">
        <img src="assets/images/team/stephen-seger.jpg" alt="Stephen Seger"
          style="width: 250px; border-radius: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.1); object-fit: cover; aspect-ratio: 1;" />
      </div>
      <div class="broker-info" style="flex: 1 1 400px;">
        <h3 style="font-size: 28px; color: var(--color-primary); margin-bottom: 5px; font-family: var(--font-serif);">
          Stephen Seger</h3>
        <p style="font-size: 18px; color: var(--color-accent); font-weight: 500; margin-bottom: 20px;">Owner & Senior
          Broker</p>
        <p style="margin-bottom: 16px; line-height: 1.6; color: #4a5568; font-size: 16px;">Stephen Seger has been a
          full-time yacht broker since 2019 having helped clients pursue thousands of yachts in the United States,
          Canada, Mexico, the Caribbean, and Europe. Stephen is a Texas-native with a first love of the water. He grew
          up fishing inshore and offshore fishing tournaments in Texas including Poco Bueno, Legends, TIFT, TWAT, and
          Babes on the Bay just to name a few.</p>
        <p style="margin-bottom: 16px; line-height: 1.6; color: #4a5568; font-size: 16px;">Stephen has been a brokerage
          owner since 2021 that specializes in both power and sail ranging from 20’ – 100'+. He is an industry expert at
          understanding the needs of buyer and seller needs during a deal and has been fortunate to be the highest
          volume broker in Texas in 2024 and 2025.</p>
        <p style="margin-bottom: 16px; line-height: 1.6; color: #4a5568; font-size: 16px;">Raised in Houston, he is
          well-connected in the Houston and Galveston area and has a driving and entrepreneurial passion to help clients
          and brokers alike in the marine industry.</p>
        <p style="margin-bottom: 0; line-height: 1.6; color: #4a5568; font-size: 16px;">Stephen can be reached at (713)
          828 – 3642 or <a href="mailto:stephen@leaguecityyachtsales.com"
            style="color: var(--color-accent); font-weight: 500;">stephen&#64;leaguecityyachtsales.com</a>.</p>
      </div>
    </div>
  </div>
</section> -->

<app-home-locations [locations]="locations"></app-home-locations>
